import { put, call, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader, openModal } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import dashboardTaskActionTypes from '../../constants/actions/dashboard/dashboardTask'
import getTaskValuesToExcel from '../../services/task/getTaskToExcel'
import { handleError } from '../errors/errorManager'

export function * getFilteredTaskToExcel ({ activeTaskId, orderby, urgencyTypeTask }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const dashboardTask = yield select(state => state.dashboardTask)
    const activeTaskValues = dashboardTask.activeTaskValues
    const maxDossierExport = activeTaskValues?.maxDossierExport || 0
    var total = activeTaskValues?.total || 0
    switch (urgencyTypeTask[0] || urgencyTypeTask) {
      case 0:
        if (activeTaskValues && activeTaskValues.total) {
          total = activeTaskValues.total
        }
        break
      case 2:
        if (activeTaskValues && activeTaskValues.totalHigh) {
          total = activeTaskValues.totalHigh
        }
        break
      case 3:
        if (activeTaskValues && activeTaskValues.totalMedium) {
          total = activeTaskValues.totalMedium
        }
        break
      case 4:
        if (activeTaskValues && activeTaskValues.totalLow) {
          total = activeTaskValues.totalLow
        }
        break
    }

    yield call(
      getTaskValuesToExcel,
      auth.token,
      activeTaskId,
      orderby,
      urgencyTypeTask,
      auth.organizedUnit
    )
    if (total > maxDossierExport) {
      yield put(hideLoader())
      yield put(openModal('dossierListExportReducedSuccess', null, null, null, null, [{ id: '##AMOUNT##', value: maxDossierExport }], null))
    }
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchGetFilteredTaskToExcel () {
  yield takeEvery(dashboardTaskActionTypes.EXPORT_TASK_TO_EXCEL, getFilteredTaskToExcel)
}
